import PropTypes from "prop-types";
import ArgonBadge from "components/ArgonBadge";

function AdminUnreadBadge({ unread, label, ...rest }) {
  if (!unread) return null;

  return (
    <ArgonBadge
      variant="gradient"
      badgeContent={label}
      color="error"
      size="xs"
      container
      {...rest}
    />
  );
}

AdminUnreadBadge.defaultProps = {
  label: "New",
};

AdminUnreadBadge.propTypes = {
  unread: PropTypes.bool.isRequired,
  label: PropTypes.string,
};

export default AdminUnreadBadge;
